import { gql } from '@apollo/client'

/**
 * Add stop mutation
 */
export const ADD_STOP = gql`
  mutation AddStop($shipmentID: ID!, $id: ID!, $sequence: Int!, $type: StopType!, $warehouse: StopWarehouseInput!) {
    stop: addStop(
      input: { shipmentID: $shipmentID, id: $id, sequence: $sequence, type: $type, warehouse: $warehouse }
    ) {
      id
      warehouse {
        name
        category
        rating
        reviews
        placeID
        thumbnail
        warehouseHours
        address {
          addressLabel
          streetNumber
          street
          city
          state
          stateCode
          county
          postalCode
          postalCodeSuffix
          country
          countryCode
          coordinates {
            latitude
            longitude
          }
        }
      }
      appointment {
        start {
          date
          time
        }
        end {
          date
          time
        }
        isFirstComeFirstServe
      }
      referenceNumber
      type
      sequence
      instructions
      eta {
        date
        time
      }
      arrivalDateTime {
        date
        time
      }
      departureDateTime {
        date
        time
      }
    }
  }
`

/**
 * Remove stop mutation
 */
export const REMOVE_STOP = gql`
  mutation RemoveStop($shipmentID: ID!, $stopID: ID!) {
    removeStop(input: { shipmentID: $shipmentID, stopID: $stopID }) {
      id
    }
  }
`

/**
 * Update stop details mutation
 * @param shipmentID is the unique id of the shipment
 * @param stopID is the unique id of the stop
 * @param instructions stop details instructions to be displayed in the list
 * @param type the type of stop. i.e, Pick or Drop
 * @param referenceNumber the non-unique reference number of the stop
 * @param appointment is the appointment date time of the stop
 */
export const UPDATE_STOP_DETAILS = gql`
  mutation UpdateStopDetails(
    $shipmentID: ID!
    $stopID: ID!
    $instructions: String
    $type: StopType
    $referenceNumber: String
    $appointment: StopAppointmentInput
  ) {
    updateStopDetails(
      input: {
        shipmentID: $shipmentID
        stopID: $stopID
        instructions: $instructions
        type: $type
        referenceNumber: $referenceNumber
        appointment: $appointment
      }
    ) {
      id
      appointment {
        start {
          date
          time
        }
        end {
          date
          time
        }
        isFirstComeFirstServe
      }
      referenceNumber
      type
      instructions
    }
  }
`

/**
 * Update stop ETA mutation
 * @param shipmentID is the unique id of the shipment
 * @param stopID is the unique id of the stop
 * @param date stop eta date to be displayed in the list
 * @param time stop eta time to be displayed in the list
 */
export const UPDATE_STOP_ETA = gql`
  mutation UpdateStopETA($shipmentID: ID!, $source: String, $stopID: ID!, $date: String!, $time: String) {
    updateStopETA(
      input: { shipmentID: $shipmentID, source: $source, stopID: $stopID, eta: { date: $date, time: $time } }
    ) {
      id
      eta {
        date
        time
      }
    }
  }
`
/**
 * Update stop arrival mutation
 * @param shipmentID is the unique id of the shipment
 * @param stopID is the unique id of the stop
 * @param date stop eta date to be displayed in the list
 * @param time stop eta time to be displayed in the list
 */
export const UPDATE_STOP_ARRIVAL = gql`
  mutation UpdateStopArrival($shipmentID: ID!, $source: String, $stopID: ID!, $date: String!, $time: String) {
    updateStopArrival(
      input: {
        shipmentID: $shipmentID
        source: $source
        stopID: $stopID
        arrivalDateTime: { date: $date, time: $time }
      }
    ) {
      id
      arrivalDateTime {
        date
        time
      }
    }
  }
`

/**
 * Update stop departure mutation
 * @param shipmentID is the unique id of the shipment
 * @param stopID is the unique id of the stop
 * @param date stop eta date to be displayed in the list
 * @param time stop eta time to be displayed in the list
 */
export const UPDATE_STOP_DEPARTURE = gql`
  mutation UpdateStopDeparture($shipmentID: ID!, $source: String, $stopID: ID!, $date: String!, $time: String) {
    updateStopDeparture(
      input: {
        shipmentID: $shipmentID
        source: $source
        stopID: $stopID
        departureDateTime: { date: $date, time: $time }
      }
    ) {
      id
      departureDateTime {
        date
        time
      }
    }
  }
`

/**
 * Mutation to update stop address
 */
export const UPDATE_STOP_ADDRESS = gql`
  mutation UpdateStopCoordinates(
    $address: JSON!
    $locationID: String!
    $shipmentID: String!
    $shipmentOwnerEnterpriseWorkspaceID: String
    $shipmentOwnerWorkspaceID: String
    $stopID: String!
  ) {
    updateStopCoordinates(
      input: {
        address: $address
        locationID: $locationID
        shipmentID: $shipmentID
        shipmentOwnerEnterpriseWorkspaceID: $shipmentOwnerEnterpriseWorkspaceID
        shipmentOwnerWorkspaceID: $shipmentOwnerWorkspaceID
        stopID: $stopID
      }
    ) {
      locationID
    }
  }
`

/**
 * Mutation to save geofence boundaries for a location
 */
export const SAVE_LOCATION_GEOFENCE = gql`
  mutation SaveLocationGeofence(
    $geofence: StopWarehouseGeofenceInput
    $locationID: String!
    $shipmentID: String!
    $shipmentOwnerEnterpriseWorkspaceID: String
    $shipmentOwnerWorkspaceID: String
    $stopID: String!
  ) {
    saveLocationGeofence(
      input: {
        geofence: $geofence
        locationID: $locationID
        shipmentID: $shipmentID
        shipmentOwnerEnterpriseWorkspaceID: $shipmentOwnerEnterpriseWorkspaceID
        shipmentOwnerWorkspaceID: $shipmentOwnerWorkspaceID
        stopID: $stopID
      }
    ) {
      locationID
      success
    }
  }
`
